import { NavLink } from 'react-router-dom';
import BrandMark from './BrandMark';

const NAV = [
  {
    group: 'Workspace',
    items: [
      { to: '/app', label: 'Overview', end: true },
      { to: '/app/pay-period', label: 'Pay period' },
      { to: '/app/payrun', label: 'Payrun' },
      { to: '/app/filings', label: 'Filings' },
    ],
  },
  {
    group: 'People',
    items: [
      { to: '/app/people', label: 'Employees' },
    ],
  },
  {
    group: 'Engine',
    items: [
      { to: '/app/engine', label: 'Connection' },
      { to: '/app/tenants', label: 'Tenants' },
      { to: '/app/regulations', label: 'Regulations' },
      { to: '/app/cases', label: 'Case data' },
      { to: '/app/pe-payruns', label: 'PE payruns' },
      { to: '/app/reports', label: 'Reports' },
      { to: '/app/tasks', label: 'Tasks' },
      { to: '/app/logs', label: 'Logs' },
    ],
  },
  {
    group: 'Account',
    items: [
      { to: '/app/settings', label: 'Settings' },
    ],
  },
];

export default function AppShell({ onLogout, children }) {
  return (
    <div className="app-frame">
      <aside className="app-nav">
        <NavLink to="/app" end className="app-nav-brand">
          <BrandMark compact />
        </NavLink>
        {NAV.map((group) => (
          <div key={group.group} className="app-nav-group">
            <div className="app-nav-label">{group.group}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={!!item.end}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
        <div className="app-nav-foot">
          <button type="button" className="btn btn-ghost" onClick={onLogout}>Log out</button>
        </div>
      </aside>
      <main className="app-main">{children}</main>
    </div>
  );
}

